import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class LoginGuard  {

    constructor(
        private _router: Router,
        private _authService: MsalService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this._authService.instance.getAllAccounts().length > 0) {
            this._router.navigate(['/app']);
            return false;
        }

        return true;
    }
}
